import {ready} from '../main/utils';
import loadCalculator from './calculator';
import loadCarousel from './carousel';
import loadGreenProducts from './green-products';
import loadWellCalculator from './well-calculator';
import loadESG from './esg';

ready(() => {
  loadCalculator();
  loadCarousel();
  loadGreenProducts();
  loadWellCalculator();
  loadESG();
});
